import type { Page } from '@sveltejs/kit';
import type { SupportedLocale } from '@viamichelin/business';
import { isCorridorPageContext } from '$lib/services/urls/routeIds';

interface LocaleSurvey {
	description: string;
	cta: string;
	closeAriaLabel: string;
	href: string;
	enabled: ((route: Page['route']) => boolean);
}

const content = new Map<SupportedLocale, LocaleSurvey>(
	[
		['fr-FR', {
			description:
				'Répondez en quelques minutes à notre questionnaire pour nous permettre de mieux connaître vos attentes ! ',
			cta: 'Je réponds',
			closeAriaLabel: 'Fermer',
			href: 'https://surveys.hotjar.com/de9a2e83-abdc-4b79-9cf9-5bc55575e28b',
			enabled: route => isCorridorPageContext(route),
		}],
		// ['it-IT', {
		// 	description:
		// 		'Rispondete in pochi minuti al nostro questionario per permetterci di conoscere meglio le vostre aspettative ! ',
		// 	cta: 'Rispondo',
		// 	closeAriaLabel: 'Chiudi',
		// 	href: 'https://chat.episto.fr/?s=ELN7Ew08__I&lg=it-FbDX&cc=IT&z=2',
		// 	enabled: () => false,
		// }],
	],
);

export const bvaSurvey = {
	delay: 5000,
	maxNbOpenPerSession: 1,
	sessionKey: 'surveyNbOpen',
	getSurveyContent(page: Page) {
		const surveyContent = content.get(page.data.locale);

		if (!surveyContent || !surveyContent.enabled(page.route)) {
			return undefined;
		}

		const { description, cta, closeAriaLabel, href } = surveyContent;

		return {
			description,
			cta,
			closeAriaLabel,
			href,
		};
	},
} as const;
